// import * as React from "react";
import classNames from "classnames";

import Box from "@mui/material/Box";
import Chip from "@mui/material/Chip";
import MenuItem from "@mui/material/MenuItem";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import Select from "@mui/material/Select"; // { SelectChangeEvent, SelectProps }

// interface ISelectComponent extends SelectProps {
//   name?: string;
//   multiple?: boolean;
//   allowNone?: boolean;
//   className?: string;
//   value?: string | number | Array<any>;
//   options: Array<{ label: string; value: string | number }>;
//   onChange: (event: SelectChangeEvent, child: React.ReactNode) => void;
// }

const MultipleChips = (selected) => (
  <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
    {selected?.map((value) => (
      <Chip key={value} label={value} />
    ))}
  </Box>
);

const SelectComponent = ({
  options,
  name = "",
  // value = "",
  multiple = false,
  allowNone = false,
  onChange,
  className = "",
  ...rest
}) => {
  return (
    <Select
      name={name}
      displayEmpty
      // value={value}
      size={"small"}
      multiple={multiple}
      onChange={onChange}
      className={className}
      style={{ width: "100%" }}
      renderValue={multiple ? MultipleChips : undefined}
      inputProps={{ "aria-label": "Without label" }}
      IconComponent={() => <KeyboardArrowDownIcon />}
      {...rest}
    >
      {allowNone ? <MenuItem value="">None</MenuItem> : null}
      {options?.map((option) => {
        const isSelected =
          multiple &&
          rest?.value?.some((s) =>
            option?.id ? option?.id : option?.value === s.id
          );
        return (
          <MenuItem
            key={option.value}
            value={option.value}
            className={classNames({ "Mui-selected": isSelected })}
          >
            {option.label}
          </MenuItem>
        );
      })}
    </Select>
  );
};

export default SelectComponent;
